module.exports = __webpack_public_path__ + "static/img/radio-phone.21ebc022.png";